



































































































import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import { IClientProviderData } from "@/models/providers/client";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      canShowNotesAndSecrets: "data/clients/vaultAssets/canShowNotesAndSecrets"
    })
  },
  components: {
    "client-stats": () =>
      import("@/components/app/admin/clients/clientStats.vue"),
    "timeline-table": () =>
      import("@/components/app/global/timelineComponent/timelineTable.vue"),
    "client-quick-actions": () =>
      import("@/components/app/global/client/clientQuickActions.vue"),
    "client-secrets-component": () =>
      import("@/components/app/global/client/clientSecretsComp.vue"),
    "client-notes-component": () =>
      import("@/components/app/global/client/clientNotesComp.vue"),
    "remote-access-summary-msg": () =>
      import("@/components/app/admin/upmind/remoteAccessSummaryMsg.vue"),
    "brands-provider": () =>
      import("@/components/app/admin/settings/brands/brandsProvider.vue"),
    "upmind-brands-grid": () =>
      import("@/components/app/admin/upmind/brandsGrid.vue"),
    "upmind-usage-provider": () =>
      import("@/components/app/global/upmind/usageProvider.vue"),
    "upmind-usage-data-grid": () =>
      import("@/components/app/global/upmind/upmindUsageDataGrid.vue")
  }
})
export default class AdminClientOverview extends Vue {
  // Getters
  public canShowNotesAndSecrets!: boolean;
  // Inject
  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;
  // Props
  @Prop({ required: true })
  public client!: IClient;

  // Life-cycle methods
  public mounted() {
    this.$bus.$emit("scrollToTop");
  }
  // Computed
  public get $clientData() {
    return this.$clientProvider();
  }
  public get isStaged() {
    return this.$clientData.isStaged;
  }
}
